<template>
  <div class="add">
    <FixedHeader :showLoginBtn="false" :showSearch="false">
      <a @click="goTo()">
        <img
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
      <b-dropdown
        v-if="user"
        position="is-bottom-left"
        :icon-left="'face'"
        class="user-dropdown"
        aria-role="list"
      >
        <b-button
          :title="user.name"
          :class="user.photo ? 'loggedin-button-image' : 'loggedin-button'"
          :icon-left="!user.photo ? 'account' : ''"
          slot="trigger"
        >
          <img class="loggedin-image" v-if="user.photo" :src="user.photo" />
        </b-button>
        <b-dropdown-item @click="userLogout" aria-role="listitem"
          >Logout</b-dropdown-item
        >
      </b-dropdown>
    </FixedHeader>
    <SocialLogin v-if="!user" />
    <Upload v-if="user" :pinwallId="pinwallId" :password="password" />
    <Footer />
  </div>
</template>

<script>
import FixedHeader from "../components/FixedHeader.vue";
import Footer from "@/components/Footer";
import Upload from "../components/pinwall/Upload";
import SocialLogin from "../components/user/SocialLogin";
import { goTo } from "../mixins/goTo.js";
import { openUsernameDialog } from "../mixins/openUsernameDialog.js";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Add",
  data: () => {
    return {
      pinwallId: "",
      password: "",
      showLogin: false
    };
  },
  components: {
    Upload,
    FixedHeader,
    Footer,
    SocialLogin
  },
  mixins: [goTo, openUsernameDialog],
  computed: {
    ...mapGetters(["user", "darkMode"])
  },
  methods: {
    ...mapMutations(["logout"]),
    userLogout() {
      this.logout();
    }
  },
  created() {
    if (this.user && !this.user.username) {
      this.openUsernameDialog(this.$t("user.enterUserName"));
    }

    this.pinwallId = this.$route.query.id;
    this.password = this.$route.query.password;
  }
};
</script>
